export const JsonLdBreadcrumbList = ({handle, title, handle2, title2, handle3, title3}) => {
  const baseHref = 'https://www.skaraudio.com';

  let position = 1;

  const json = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: position,
        item: {
          '@id': baseHref,
          name: 'Home'
        }
      }
    ]
  };

  if (handle && title) {
    position = position + 1;
    json.itemListElement.push({
      '@type': 'ListItem',
      position: position,
      item: {
        '@id': baseHref + handle,
        name: title
      }
    });
  }

  if (handle2 && title2) {
    position = position + 1;
    json.itemListElement.push({
      '@type': 'ListItem',
      position: position,
      item: {
        '@id': baseHref + handle2,
        name: title2
      }
    });
  }

  if (handle3 && title3) {
    position = position + 1;
    json.itemListElement.push({
      '@type': 'ListItem',
      position: position,
      item: {
        '@id': baseHref + handle3,
        name: title3
      }
    });
  }

  // console.dir({breadCrumbs_json: json}, {depth: null})
  return (
    <script type='application/ld+json' dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />
  );
};
